/**
 * Componente Pago de Reserva — versión simplificada de aproveedor.
 * Exclusivo para Flieben Capital. Solo funciona con ajustes detalles (endpoint PD).
 * Sin radio SIN/CON recurso. Sin moratorios. Selección de cadena.
 * Fecha: 01/10/2026
 */
import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { PagosService, OptionsService, PaymentDetailsService, PAYMENT_DETAIL_CONFIG, InvoicePD } from '../../../services/service.index';
import { AltaSolicitudesService } from '../../../services/altasolicitudes/altasolicitudes.service';
import swal2 from 'sweetalert2';

@Component({
  selector: 'app-pago-reserva',
  templateUrl: './pago-reserva.component.html',
  styleUrls: ['../../alta solicitudes/altasolicitudes.component.css']
})
export class PagoReservaComponent implements OnInit {
  @ViewChild('dt', { static: false }) tabla: Table;

  // Paginación y selección (patrón aproveedor)
  filasPorPagina: number = 100;
  opcionesTamanoPagina: number[] = [20, 50, 100];
  paginaActualSeleccionada: boolean = false;
  paginaActualIndeterminada: boolean = false;
  todasSeleccionadas: boolean = false;

  cols: any[];
  fecha: string;
  cadenas: any[] = [];
  correo: string = '';
  facturas: any[] = [];
  selectedFac: any[] = [];
  idp: string = '';
  idcontribuyente: string = '';
  idcontfinan: string = '';
  totalFac: number = 0;
  totalFacs: string = '0';
  totalFacsFormateado: string = '0';
  currency: any[] = [];
  paymentTypes: any[] = [];
  nomname: string = '';
  selectedBank: string = '';
  banks: any[] = [];
  hayBancos: boolean = false;
  npago: string = '';

  // [01/10/2026] Flag de ajustes detalles: si no está activo, la pantalla no opera
  funcionalidadHabilitada: boolean = false;

  constructor(
    public _pagosservice: PagosService,
    public _optionsservice: OptionsService,
    private _solicitudesservice: AltaSolicitudesService,
    private _paymentDetailsService: PaymentDetailsService
  ) {}

  ngOnInit() {
    swal2.fire({
      title: 'Cargando',
      allowOutsideClick: false
    });
    swal2.showLoading();

    const a = new Date();
    a.setMinutes(a.getMinutes() + a.getTimezoneOffset());
    let montha = '' + (a.getMonth() + 1);
    let daya = '' + a.getDate();
    const yeara = a.getFullYear();
    if (montha.length < 2) { montha = '0' + montha; }
    if (daya.length < 2) { daya = '0' + daya; }
    this.fecha = [yeara, montha, daya].join('-');

    // Reiniciar estado
    this.totalFacs = '0';
    this.totalFacsFormateado = '0';
    this.selectedFac = [];
    this.facturas = [];
    this.correo = '';
    this.idp = '';
    this.totalFac = 0;

    // [05/10/2026] Columnas PD: 12 columnas exactas según imagen del usuario
    this.cols = [
      { field: 'folio_reporte', header: 'Folio Reporte' },
      { field: 'folio_factura', header: 'Folio Factura' },
      { field: 'uuid', header: 'UUID' },
      { field: 'total_a_pagar', header: 'Total a Pagar' },
      { field: 'emisor', header: 'Emisor' },
      { field: 'receptor', header: 'Receptor' },
      { field: 'moneda', header: 'Moneda' },
      { field: 'fecha_operacion', header: 'Fecha Operación' },
      { field: 'fecha_vencimiento', header: 'Fecha Vencimiento' },
      { field: 'fecha_emision', header: 'Fecha Emisión' },
      { field: 'fecha_carga', header: 'Fecha Carga' },
      { field: 'estatus', header: 'Estatus' }
    ];

    // Cargar cadenas (patrón decadena: getCadenas → payment_companies)
    this._pagosservice.getCadenas().subscribe(resp => {
      this.cadenas = resp;
      swal2.close();
    });

    // Nombre de la financiera
    this._solicitudesservice.getGeneralParam('NOMBRE_FINANCIERA').subscribe(resp => {
      this.nomname = resp['value'];
    });

    // Moneda y tipos de pago
    this._solicitudesservice.getPaymentCurrency().subscribe(resp => this.currency = resp);
    this._solicitudesservice.getPaymentTypes().subscribe(resp => this.paymentTypes = resp);

    // Bancos
    this._pagosservice.getAcountigAcountBanks().subscribe(resp => {
      this.banks = resp;
      this.hayBancos = resp && resp.length > 0;
    });

    // [01/10/2026] Verificar flag PD para pago de reserva
    this._paymentDetailsService.checkFlag(PAYMENT_DETAIL_CONFIG.PAGO_RESERVA.flag).subscribe(activo => {
      this.funcionalidadHabilitada = activo;
    });
  }

  /**
   * [01/10/2026] Extrae ids y correo de la cadena seleccionada.
   * Patrón similar a decadena.component.ts con array cadenas.
   */
  getcorreo() {
    this.facturas = [];
    this.selectedFac = [];
    this.paginaActualSeleccionada = false;
    this.paginaActualIndeterminada = false;
    this.todasSeleccionadas = false;
    this.totalFacsFormateado = '0';
    const select: any = document.getElementById('cadena');
    const valor = select.options[select.selectedIndex].value;
    for (const prop in this.cadenas) {
      if (this.cadenas[prop].id_cadena == valor) {
        this.idp = this.cadenas[prop].id_cadena;
        this.correo = this.cadenas[prop].email_contribuyente;
        this.idcontribuyente = this.cadenas[prop].id_contribuyente;
        this.idcontfinan = this.cadenas[prop].id_cont_finan;
      }
    }
  }

  /**
   * [01/10/2026] Consulta facturas con reserva pendiente desde endpoint PD.
   * Si el flag no está activo, muestra mensaje informativo.
   */
  muestraFacturas() {
    if (this.idp === '') {
      swal2.fire('Debe seleccionar una cadena', '', 'error');
      return;
    }

    // Si la funcionalidad no está habilitada, informar al usuario
    if (!this.funcionalidadHabilitada) {
      swal2.fire(
        'Funcionalidad no habilitada',
        'El ajuste de detalle para Pago de Reserva no está activo. Contacte al administrador.',
        'info'
      );
      return;
    }

    swal2.fire({
      title: 'Cargando',
      allowOutsideClick: false
    });
    swal2.showLoading();

    this._paymentDetailsService.getInvoicesPD(
      Number(this.idcontfinan),
      Number(this.idcontribuyente),
      PAYMENT_DETAIL_CONFIG.PAGO_RESERVA.tipoRegistroPago
    ).subscribe(resp => {
      swal2.close();
      this.facturas = this.mapearFacturasPD(resp);
      if (this.facturas.length === 0) {
        swal2.fire('No se encontraron Datos', '', 'error');
      }
    }, (err) => {
      swal2.close();
      console.log(err);
      const titulo = (err && err.status === 422)
        ? 'Error de configuración en ajustes detalles'
        : 'Ocurrió un error al consultar ajustes detalles';
      swal2.fire({
        title: titulo,
        text: '',
        icon: 'error',
        showConfirmButton: true,
        showCancelButton: false,
        allowOutsideClick: false
      }).then(res => {
        if (res.value) { this.ngOnInit(); }
      });
    });
  }

  /**
   * [05/10/2026] Mapea facturas del endpoint PD al formato de tabla con 12 columnas de la imagen.
   * Para reserva: sin moratorios ni días vencidos.
   * Se mantiene saldo_pendiente_fmt mapeado desde total_a_pagar para compatibilidad con getTotal().
   */
  mapearFacturasPD(facturas: InvoicePD[]): any[] {
    return facturas
      .filter(f => f.payment_status !== 'PAGADO')
      .map(f => ({
        id_factura: f.invoice_id,
        folio_reporte: f.folio_reporte,
        folio_factura: f.folio_factura,
        uuid: f.uuid,
        total_a_pagar: this._paymentDetailsService.formatearMonto(f.total_a_pagar),
        emisor: f.emisor,
        receptor: f.receptor,
        moneda: f.moneda,
        fecha_operacion: f.fecha_operacion,
        fecha_vencimiento: f.fecha_vencimiento,
        fecha_emision: f.fecha_emision,
        fecha_carga: f.fecha_carga,
        estatus: f.estatus_factura,
        // [05/10/2026] saldo_pendiente_fmt se mantiene para compatibilidad con getTotal()
        saldo_pendiente_fmt: this._paymentDetailsService.formatearMonto(f.total_a_pagar),
        es_parcial: f.payment_status === 'PARCIAL'
      }));
  }

  /**
   * [01/10/2026] Calcula el total de las facturas seleccionadas.
   * Suma saldo_pendiente_fmt (patrón aproveedor con parseFloat y replace de comas).
   */
  getTotal() {
    let tp = 0;
    if (this.selectedFac.length === 0) {
      this.totalFac = 0;
    } else {
      for (const prop in this.selectedFac) {
        tp = tp + parseFloat(this.selectedFac[prop].saldo_pendiente_fmt.replace(/,/g, ''));
      }
    }
    this.totalFacs = tp.toFixed(2);
    this.totalFacsFormateado = tp.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // --- Selección con paginación (patrón aproveedor) ---

  obtenerFilasPaginaActual(): any[] {
    if (!this.tabla) { return []; }
    const datos = this.tabla.filteredValue || this.tabla.value || [];
    const inicio = this.tabla.first || 0;
    const fin = inicio + (this.tabla.rows || this.filasPorPagina);
    return datos.slice(inicio, fin);
  }

  toggleSeleccionPagina(): void {
    const filasPagina = this.obtenerFilasPaginaActual();
    const todasSel = filasPagina.length > 0 && filasPagina.every(fila => this.selectedFac.includes(fila));
    if (todasSel) {
      this.selectedFac = this.selectedFac.filter(fila => !filasPagina.includes(fila));
    } else {
      const nuevas = filasPagina.filter(fila => !this.selectedFac.includes(fila));
      this.selectedFac = [...this.selectedFac, ...nuevas];
    }
    this.actualizarEstadoCheckboxPagina();
    this.getTotal();
  }

  actualizarEstadoCheckboxPagina(): void {
    const filasPagina = this.obtenerFilasPaginaActual();
    if (filasPagina.length === 0) {
      this.paginaActualSeleccionada = false;
      this.paginaActualIndeterminada = false;
      return;
    }
    const seleccionadas = filasPagina.filter(fila => this.selectedFac.includes(fila)).length;
    this.paginaActualSeleccionada = seleccionadas === filasPagina.length;
    this.paginaActualIndeterminada = seleccionadas > 0 && seleccionadas < filasPagina.length;
  }

  toggleSeleccionTodas(): void {
    const datos = (this.tabla && this.tabla.filteredValue) ? this.tabla.filteredValue : this.facturas;
    if (this.todasSeleccionadas) {
      this.selectedFac = [];
    } else {
      this.selectedFac = [...datos];
    }
    this.todasSeleccionadas = !this.todasSeleccionadas;
    this.actualizarEstadoCheckboxPagina();
    this.getTotal();
  }

  actualizarEstadoCheckboxTodas(): void {
    const datos = (this.tabla && this.tabla.filteredValue) ? this.tabla.filteredValue : this.facturas;
    this.todasSeleccionadas = datos.length > 0 && this.selectedFac.length === datos.length;
  }

  /**
   * [01/10/2026] Registra el pago de reserva.
   * Usa payment_source 'RESERVA' y aplicarPagoRAWproveedor (mismo POST /payments).
   * contributor_from_id = financiera, contributor_to_id = cadena.
   */
  guardar() {
    if (this.selectedFac.length === 0) {
      swal2.fire('Debe seleccionar al menos una Factura', '', 'error');
      return;
    }

    const tpago: any = document.getElementById('tdpago');
    const moneda: any = document.getElementById('moneda');
    const valortpago = tpago.options[tpago.selectedIndex].value;
    const valormoneda = moneda.options[moneda.selectedIndex].value;

    const payment: any = {
      payment_date: (document.getElementById('fecha') as HTMLInputElement).value,
      payment_number: (document.getElementById('npago') as HTMLInputElement).value,
      payment_type: valortpago,
      currency: valormoneda,
      amount: this.totalFacs,
      email_cfdi: (document.getElementById('correo') as HTMLInputElement).value,
      notes: (document.getElementById('notas') as HTMLInputElement).value,
      voucher: (document.getElementById('voucher') as HTMLInputElement).value,
      contributor_from_id: this.idcontfinan,
      contributor_to_id: this.idcontribuyente
    };

    if (this.hayBancos && this.selectedBank) {
      payment.bank = this.selectedBank;
    }

    const params = {
      payment_source: 'RESERVA',
      invoices: [],
      payment: payment
    };

    // tslint:disable-next-line: forin
    for (const prop in this.selectedFac) {
      params.invoices[prop] = { id: this.selectedFac[prop].id_factura.toString() };
    }

    swal2.fire({
      title: 'Procesando pago',
      text: 'Registrando la información...',
      allowOutsideClick: false
    });
    swal2.showLoading();

    this._pagosservice.aplicarPagoRAWproveedor(params).subscribe(resp => {
      swal2.close();
      swal2.fire({
        title: 'La información se registró',
        text: 'con éxito',
        icon: 'success',
        showConfirmButton: true,
        showCancelButton: false,
        allowOutsideClick: false
      }).then(res => {
        if (res.value) {
          window.location.reload();
        }
      });
    }, (err) => {
      swal2.close();
      console.log(err);
      swal2.fire({
        title: 'Ocurrio un error',
        text: err.error.errors[0],
        icon: 'error',
        showConfirmButton: true,
        showCancelButton: false,
        allowOutsideClick: false
      }).then(res => {
        if (res.value) {
          this.ngOnInit();
        }
      });
    });
  }
}
